(function () {
  function initMarquee(root) {
    const marquees = root.querySelectorAll('[data-tp-marquee]');

    marquees.forEach((marquee) => {
      if (marquee.dataset.tpMarqueeReady === 'true') return;
      marquee.dataset.tpMarqueeReady = 'true';

      const track = marquee.querySelector('[data-tp-marquee-track]');
      const viewport = marquee.querySelector('.tp-marquee__viewport');
      if (!track || !viewport) return;

      const sourceItems = Array.from(track.querySelectorAll('.tp-marquee__item.is-source'));
      if (!sourceItems.length) return;

      const buildInfiniteTrack = () => {
        track.querySelectorAll('.tp-marquee__item.is-clone').forEach((node) => node.remove());

        const first = sourceItems[0];
        const last = sourceItems[sourceItems.length - 1];
        if (!first || !last) return;

        const sourceWidth = Math.max(1, Math.round(last.offsetLeft + last.offsetWidth - first.offsetLeft));
        const viewportWidth = Math.max(1, viewport.clientWidth);

        const minCopies = Math.max(2, Math.ceil((viewportWidth * 2) / sourceWidth) + 1);

        for (let copy = 0; copy < minCopies; copy += 1) {
          sourceItems.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.classList.remove('is-source');
            clone.classList.add('is-clone');
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a').forEach((anchor) => anchor.setAttribute('tabindex', '-1'));
            track.appendChild(clone);
          });
        }

        const speed = Number.parseFloat(marquee.dataset.speed || '90') || 90;
        const duration = Math.max(8, sourceWidth / speed);

        marquee.style.setProperty('--tp-marquee-distance', sourceWidth + 'px');
        marquee.style.setProperty('--tp-marquee-duration', duration.toFixed(2) + 's');
      };

      window.requestAnimationFrame(buildInfiniteTrack);

      let resizeFrame = null;
      window.addEventListener('resize', () => {
        if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(() => {
          resizeFrame = null;
          buildInfiniteTrack();
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMarquee(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initMarquee(event.target);
  });
})();
